import {
  CheckCircle2, Clock, XCircle, Ban, FileText, Archive, AlertCircle, Truck, RefreshCw,
} from "lucide-react";

/**
 * Uniform status pill used across every admin table.
 * One vocabulary → one look → instant table-scan for the admin.
 *
 * Green (olive)  = approved · active · paid · delivered · verified · completed
 * Amber (gold)   = pending · submitted · processing · queued · approved-not-yet-paid
 * Rose  (rose)   = rejected · cancelled · failed · blocked · refunded
 * Slate (navy)   = draft · legacy · archived · unknown
 */
const MAP = {
  // green
  approved:   { tone: "olive", icon: CheckCircle2 },
  active:     { tone: "olive", icon: CheckCircle2 },
  paid:       { tone: "olive", icon: CheckCircle2 },
  delivered:  { tone: "olive", icon: Truck },
  verified:   { tone: "olive", icon: CheckCircle2 },
  completed:  { tone: "olive", icon: CheckCircle2 },
  live:       { tone: "olive", icon: CheckCircle2 },
  resolved:   { tone: "olive", icon: CheckCircle2 },
  success:    { tone: "olive", icon: CheckCircle2 },

  // amber
  pending:    { tone: "gold",  icon: Clock },
  submitted:  { tone: "gold",  icon: Clock },
  processing: { tone: "gold",  icon: RefreshCw },
  queued:     { tone: "gold",  icon: Clock },
  open:       { tone: "gold",  icon: AlertCircle },
  in_progress:{ tone: "gold",  icon: RefreshCw },
  shipped:    { tone: "gold",  icon: Truck },

  // rose
  rejected:   { tone: "rose",  icon: XCircle },
  cancelled:  { tone: "rose",  icon: XCircle },
  canceled:   { tone: "rose",  icon: XCircle },
  failed:     { tone: "rose",  icon: XCircle },
  blocked:    { tone: "rose",  icon: Ban },
  refunded:   { tone: "rose",  icon: XCircle },

  // slate
  draft:      { tone: "slate", icon: FileText },
  legacy:     { tone: "slate", icon: Archive },
  archived:   { tone: "slate", icon: Archive },
  inactive:   { tone: "slate", icon: Ban },
  none:       { tone: "slate", icon: Archive },
  not_submitted: { tone: "slate", icon: FileText },
};

const TONE_CLS = {
  olive: "bg-olive/10 text-olive border-olive/25",
  gold:  "bg-gold/10 text-gold-deep border-gold/25",
  rose:  "bg-rose/10 text-rose border-rose/25",
  slate: "bg-navy/5 text-navy/60 border-navy/15",
};

export default function StatusPill({ status, size = "md", className = "" }) {
  const key = (status || "unknown").toString().toLowerCase().trim().replace(/[ -]/g, "_");
  const cfg = MAP[key] || { tone: "slate", icon: AlertCircle };
  const Icon = cfg.icon;
  const cls = TONE_CLS[cfg.tone];
  const pad = size === "sm" ? "px-1.5 py-0 text-[9px]" : "px-2 py-0.5 text-[10px]";
  const iconSize = size === "sm" ? 9 : 10;
  const label = (status || "—").toString().replace(/_/g, " ");
  return (
    <span
      data-testid={`status-pill-${key}`}
      className={`inline-flex items-center gap-1 rounded-sm border uppercase tracking-wider ${pad} ${cls} ${className}`}
    >
      <Icon size={iconSize} className={key === "processing" || key === "in_progress" ? "animate-spin" : ""} />
      {label}
    </span>
  );
}
